// extracted by mini-css-extract-plugin
export var button = "_m9-2";
export var card = "_m9-0";
export var closeButtonContainer = "_m9-3";
export var iconContainer = "_m9-1";